import router from '../router'

export default (Vue) => {
  Vue.prototype.$clone = function (obj) {
    return JSON.parse(JSON.stringify(obj))
  }
  Vue.prototype.$isNum = function (val) {
    return typeof (val) === 'number'
  }
  Vue.prototype.$changeUrlParam = function (params) {
    router.push({
      query: Object.assign({}, router.app._route.query, params)
    })
  }
  Vue.prototype.$openCandidateModal = function (candidateId, params = {}) {
    const {
      candidate_job_id,
      candidate_only_this_job,
      candidate_tab,
      scoreform_id,
      candidate_job_stage_id
    } = params

    router.push({
      query: Object.assign({}, router.app._route.query, {
        candidate_id: candidateId || undefined,
        candidate_job_id,
        candidate_only_this_job,
        candidate_tab,
        scoreform_id,
        candidate_job_stage_id
      })
    })
  }
  Vue.prototype.$subString = function (text, limit) {
    return text.length > limit ? text.substring(0, limit) + '...' : text
  }
}



// WEBPACK FOOTER //
// ./src/utils/Helpers.js